<div
  class="atlas-navbar__transition atlas-navbar__item"
  [ngClass]="[customClass]"
  [class.atlas-navbar__item--interactable]="isInteractable"
  >
  @if (icon) {
    <div class="atlas-navbar__item__icon__wrapper">
      <i class="material-icons">{{ icon }}</i>
      @if (iconText) {
        <div class="icon-text">{{ iconText }}</div>
      }
      @if (badgeContent) {
        <atlas-chip class="atlas-navbar__item__badge">
          {{ badgeContent }}
        </atlas-chip>
      }
    </div>
  }
  <ng-content></ng-content>
</div>
